import {defineMessages} from 'react-intl';

export const scormMessages = defineMessages({
  progressSaved: { id: 'scorm.progress_saved' },
  closeSafely: {
    id: 'scorm.close_safely',
  },
});
